import { AsyncRequestStatus } from "@ane/core/lib/models";
import { compareIgnoreCase } from "@ane/core/lib/utils/CommonStringUtils";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { StudyOperations, ExperimentStates, ProgressionCategory, ProgressionType } from "@ane/exp-data/lib/models";
import ___default from "lodash";
class ProgressionStageUtils {
  parseExperimentJournalResponse(response, prevData) {
    if (response && response.journalEntries) {
      return {
        status: AsyncRequestStatus.Completed,
        data: {
          jounalEntries: response.journalEntries.map((je) => {
            return {
              entryTime: je.EntryTime ? new Date(je.EntryTime) : null,
              entity: je.Entity,
              entryComment: je.EntryComment,
              changingUser: je.ChangingUser,
              eventType: je.EventType
            };
          })
        }
      };
    }
    return prevData;
  }
  getProgressionStageOperationConfirmationInfo(operationType, progressionIterated) {
    switch (operationType) {
      case StudyOperations.start:
        return {
          header: "Start Progression Stage",
          message: progressionIterated ? "Starting this stage will expose the feature to the selected audience. This operation does not guarantee consistent flight assignment between the previous and current iteration of the stage. Would you like to proceed?" : "Starting this stage will expose the feature to the selected audience. Would you like to proceed?"
        };
      case StudyOperations.restart:
        return {
          header: "Restart Progression Stage",
          message: "Restarting this stage will restart the feature at the first traffic step. Modifying future traffic steps will not guarantee consistent assignment between the previous and new iteration of this stage. Would you like to proceed?"
        };
      case StudyOperations.advance:
        return {
          header: "Advance Progression Stage",
          message: "Advancing this stage will ramp up the traffic exposure of the feature to the selected audience. Would you like to proceed?"
        };
      case StudyOperations.stop:
        return {
          header: "Stop Progression Stage",
          message: "Stopping this stage will prevent this audience from seeing this feature. Once the stage is stopped, restarting or starting a new stage with the same audience will not guarantee consistent flight assignment. Would you like to proceed?"
        };
      case StudyOperations.transfer:
        return {
          header: "Progression Stage Transfer",
          message: EnvironmentService.updateAssignmentInconsistencyForTransfer() ? "Transfer will move the traffic exposed in the previous progression stage to this stage. Would you like to proceed?" : "Transfer will move the traffic exposed in the previous progression stage to this stage. This transfer does not guarantee consistent flight assignment between the previous and new stages. Would you like to proceed?"
        };
      default:
        throw new Error(`Operation confirmation info for the operation type ${StudyOperations[operationType]} is not defined`);
    }
  }
  /*
    Delete Criteria:
    1.No blocking gates
    2.State has to be New
    3.Either FreeForm category progression or OverrideSet type progression
  */
  canDeleteProgressionStage(progressionStage, progressionCategory, progressionType, gates) {
    const isUpdateGated = ___default.some(gates);
    return compareIgnoreCase(progressionStage.state.State, ExperimentStates.NEW) && !isUpdateGated && (progressionCategory === ProgressionCategory.FreeForm || progressionType === ProgressionType.OverrideSetProgression);
  }
}
const progressionStageUtils = new ProgressionStageUtils();
export {
  ProgressionStageUtils,
  progressionStageUtils
};
//# sourceMappingURL=ProgressionStageUtils.js.map
